import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Full-page session restore loader — shown while AuthContext verifies the
// stored session on mount (e.g. when a URL is pasted into a new tab).
// Matches the LoginPage dark gradient so the transition feels seamless.
function SessionRestoreLoader() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 20,
        background: 'linear-gradient(135deg, #0F2A47 0%, #1B3A5C 50%, #0F2A47 100%)',
      }}
    >
      <div
        style={{
          display: 'inline-flex',
          background: 'linear-gradient(135deg, #1B6AEE 0%, #6366f1 100%)',
          padding: 14,
          borderRadius: 16,
          boxShadow: '0 4px 24px rgba(27,106,238,0.35)',
        }}
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="m8 3 4 8 5-5 5 15H2L8 3z" />
        </svg>
      </div>

      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        style={{ animation: 'peak-spin 0.9s linear infinite' }}
        aria-label="Restoring session…"
      >
        <circle
          cx="18" cy="18" r="15"
          fill="none"
          stroke="rgba(255,255,255,0.12)"
          strokeWidth="3"
        />
        <path
          d="M18 3 a15 15 0 0 1 15 15"
          fill="none"
          stroke="#1B6AEE"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>

      <span
        style={{
          color: 'rgba(255,255,255,0.65)',
          fontSize: 14,
          fontFamily: '"Bull Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          letterSpacing: '0.01em',
        }}
      >
        Restoring your session…
      </span>

      <style>{`@keyframes peak-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <SessionRestoreLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
